<template>
    <div class="d-inline-block">
        <i :id="id" class="fa fa-question-circle popover-help ml-2" />
        <b-popover v-bind="$attrs" v-on="$listeners" :target="id" triggers="hover" placement="right">
            <slot name="custom-title">
                <p class="font-weight-bold mb-1">
                    {{ $t('title') }}
                </p>
            </slot>
            <slot>
                <p class="mb-1" v-for="p in html" :key="p" v-html="p" />
            </slot>
        </b-popover>
    </div>
</template>

<script>
export default {
    name: 'PopoverHelp',
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            required: false,
            default: 'popover-help',
        },
        html: {
            type: Array,
            required: true,
        },
    },
    i18n: {
        messages: {
            'en-US': {
                title: 'How to fill out this field?',
            },
            'es-ES': {
                title: '¿Cómo llenar este campo?',
            },
            'pt-BR': {
                title: 'Como preencher este campo?',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
i.popover-help {
    color: #009ada;
}
</style>
